import { render } from "./order-payment.vue?vue&type=template&id=bda8eec2&scoped=true"
import script from "./order-payment.vue?vue&type=script&lang=js"
export * from "./order-payment.vue?vue&type=script&lang=js"

import "./order-payment.vue?vue&type=style&index=0&id=bda8eec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda8eec2"]])

export default __exports__